import React from 'react';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import './src/styles/global.css';


const theme = responsiveFontSizes(createTheme({
  typography: {
    fontFamily: 'Noto Sans Regular, Arial',
  },
  palette: {
    primary: {
      main: '#3B5060',
    },
    secondary: {
      main: '#3B5060',
    },
  },
}));

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      {element}
    </ThemeProvider>
  )
};
